const APPLE_APP_BANNER_SELECTOR = 'meta[name="apple-itunes-app"]'

export const passUrlToAppleAppBanner = (href = window.location.href) => {
  const banner = document.querySelector<HTMLMetaElement>(APPLE_APP_BANNER_SELECTOR)

  if (!banner) {
    return
  }

  const appId = banner.content
    .split(',')
    .map((entry) => entry.trim())
    .find((entry) => entry.startsWith('app-id='))

  if (appId) {
    banner.content = `${appId}, app-argument=${href}`
  }
}
